var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "bj-modal",
        {
          attrs: { size: "sm", title: "Order Report" },
          model: {
            value: _vm.visible,
            callback: function($$v) {
              _vm.visible = $$v
            },
            expression: "visible"
          }
        },
        [
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _c(
                "div",
                { staticClass: "row gutter-sm" },
                [
                  _c(
                    "q-field",
                    {
                      staticClass: "col-8",
                      attrs: {
                        error: _vm.get(_vm.$v.payload, "business_id.$error"),
                        "error-label": "This field is required"
                      }
                    },
                    [
                      _c("autocomplete", {
                        attrs: {
                          method: "autocompleteBusiness",
                          placeholder: "Business..."
                        },
                        on: {
                          change: _vm.businessSelected,
                          clear: function($event) {
                            _vm.payload.business_id = null
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-field",
                    {
                      staticClass: "col-4",
                      attrs: {
                        error: _vm.get(_vm.$v.payload, "type.$error"),
                        "error-label": "This field is required"
                      }
                    },
                    [
                      _c("q-select", {
                        attrs: {
                          "float-label": "Report Type",
                          options: _vm.inspectionTypesOptions
                        },
                        on: { input: _vm.typeSelected },
                        model: {
                          value: _vm.payload.type,
                          callback: function($$v) {
                            _vm.$set(_vm.payload, "type", $$v)
                          },
                          expression: "payload.type"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-field",
                    {
                      staticClass: "col-6",
                      attrs: {
                        error: _vm.get(_vm.$v.payload, "property_id.$error"),
                        "error-label": "This field is required"
                      }
                    },
                    [
                      _c("autocomplete", {
                        attrs: {
                          method: "autocompleteProperty",
                          disable: !_vm.payload.business_id,
                          filters: _vm.payload.business_id
                            ? { business_id: _vm.payload.business_id }
                            : null,
                          placeholder: "Property..."
                        },
                        on: { change: _vm.propertySelected }
                      })
                    ],
                    1
                  ),
                  _vm.selectedProperty &&
                  _vm.get(_vm.selectedProperty, "units[1]")
                    ? _c(
                        "q-field",
                        {
                          staticClass: "col-6",
                          attrs: {
                            error: _vm.get(_vm.$v.payload, "unit_id.$error"),
                            "error-label": "This field is required"
                          }
                        },
                        [
                          _c("select-property-unit", {
                            attrs: {
                              "property-id": _vm.payload.property_id,
                              "current-unit-id": _vm.payload.unit_id
                            },
                            on: { change: _vm.unitSelected }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "q-field",
                    {
                      staticClass: "col-6",
                      attrs: {
                        error: _vm.get(
                          _vm.$v.payload,
                          "associated_business_user_id.$error"
                        ),
                        "error-label": "This field is required"
                      }
                    },
                    [
                      _c("autocomplete", {
                        attrs: {
                          placeholder: "Associated business member",
                          method: "autocompleteBusinessVerifiedUsers",
                          "min-characters": 0,
                          filters: _vm.payload.business_id
                            ? { business_id: _vm.payload.business_id }
                            : null,
                          disable: !_vm.payload.business_id,
                          "hits-per-page": 100
                        },
                        on: { change: _vm.userSelected }
                      })
                    ],
                    1
                  ),
                  _vm.requiredDatesArray.includes(this.payload.type)
                    ? _c(
                        "q-field",
                        {
                          staticClass: "col-6",
                          attrs: {
                            error: _vm.get(
                              _vm.$v.payload,
                              "preferred_from.$error"
                            ),
                            "error-label": "This field is required"
                          }
                        },
                        [
                          _c("q-datetime", {
                            attrs: {
                              type: _vm.isTimeRequired ? "datetime" : "date",
                              "stack-label":
                                "Preferred Inspection at (in property timezone)",
                              format: _vm.isTimeRequired
                                ? "MM/DD/YY h:mmA"
                                : "MM/DD/YY"
                            },
                            model: {
                              value: _vm.payload.preferred_from,
                              callback: function($$v) {
                                _vm.$set(_vm.payload, "preferred_from", $$v)
                              },
                              expression: "payload.preferred_from"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c("bj-inner-loading", {
                attrs: { label: "Saving", visible: _vm.loading }
              })
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "q-btn-group",
                { attrs: { rounded: "", flat: "" } },
                [
                  _c("q-btn", {
                    attrs: {
                      disable: _vm.loading,
                      rounded: "",
                      color: "primary",
                      icon: "save",
                      size: "lg",
                      outline: "",
                      label: "Open Report Order",
                      "no-caps": ""
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.add($event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }